import { render, staticRenderFns } from "./LocalPreloader.vue?vue&type=template&id=1b17af30&"
import script from "./LocalPreloader.vue?vue&type=script&lang=js&"
export * from "./LocalPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports